import NavButton from 'containers/user/home/components/shared/navigation-button';

import useGoalMonitoringVisibility from 'hooks/use-goal-monitoring-visibility';

import Icons from 'assets/icons';

import type { Goal, CriticalElement } from 'containers/user/goals/use-goals';

interface GoalItemContentProps {
  goal: Goal;
}

const GoalItemContent = ({ goal }: GoalItemContentProps): React.JSX.Element => (
  <div className="flex flex-col justify-center items-start">
    <div className="font-semibold mb-2 text-left">{goal.summary}</div>
  </div>
);

interface CriticalElementsListProps {
  elements: CriticalElement[];
}

const CriticalElementsList = ({
  elements,
}: CriticalElementsListProps): React.JSX.Element | null => {
  if (!elements.length) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="font-semibold text-sm mb-2">Critical Elements</div>

      <ul className="list-disc pl-5 text-gray-600">
        {elements.map((element, index) => (
          <li key={index} className="text-sm mb-1">
            {element.summary}
          </li>
        ))}
      </ul>
    </div>
  );
};



interface GoalItemProps {
  goal: Goal;
  isCurrentFiscalYear: boolean;
}

const GoalItem = ({
  goal,
  isCurrentFiscalYear,
}: GoalItemProps): React.JSX.Element => {
  const { shouldShowMonitoring, isLoading } = useGoalMonitoringVisibility(
    goal?.criticalElements || [],
    isCurrentFiscalYear,
  );

  return (
    <div className="bg-navy-50 px-5 py-4 rounded-md w-72 min-h-28 flex flex-col border border-navy-100">
      {goal.category === 'Other' ? (
        <div className="flex flex-col justify-center items-start">
          <div className="font-semibold text-left">{goal.name}</div>
        </div>
      ) : (
        <GoalItemContent goal={goal} />
      )}
      <CriticalElementsList elements={goal.criticalElements ?? []} />
      {isLoading ? (
        <div className="mt-3 inline-flex items-center text-gray-600">
          <Icons.Spinner customClass="w-4 h-4 animate-spin" aria-hidden="true" />
        </div>
      ) : shouldShowMonitoring ? (
        <NavButton
          link={`/goals/${goal.id}/monitoring`}
          text="Monitoring"
          customClass="mt-3"
        />
      ) : null}
    </div>
  );
};

export default GoalItem;
